import { store } from "../../..";
import {
    clubhouseActions,
    selectSelectedTeam,
} from "../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../features/global/globalSlice";
import { getTeam } from "../../../lib/api";
import { ILeague } from "../../../types/api";

const createGameClubhouseLoader = async ({ params }: any) => {
    const teamId = parseInt(params.teamId);
    const settings = store.getState().global.settings;
    const fields = store.getState().global.fields;
    const league = store.getState().clubhouse.league;
    let currentTeam = selectSelectedTeam(store.getState());
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !fields.length && promises.push(store.dispatch(globalActions.getFields()));

    if (!currentTeam) {
        [{ team: currentTeam }] = await Promise.all([getTeam(teamId)]);
        currentTeam = selectSelectedTeam(store.getState());
    }

    const currentYear = parseInt(
        selectSetting(store.getState(), "majorybl_current_league_year")
            ?.setting,
    );

    const currentTeamsLeague = currentTeam?.leagues?.find(
        l => l.year === currentYear,
    );

    !league &&
        promises.push(
            store.dispatch(
                clubhouseActions.getLeague(
                    currentTeamsLeague?.id as ILeague["id"],
                ),
            ),
        );

    await Promise.all(promises);

    return {
        teamId,
        currentTeam,
    };
};

export default createGameClubhouseLoader;
